module.exports = __webpack_public_path__ + "static/media/mmume_04.cfe9cf51.png";